<%--
@Project Name: 赛橙表
@Author: liu.yang
@Date: 2019-09-26 10:23
@Email: 849941112@qq.com
@Idea: WebStorm
--%>

<template>
    <div id="root" class="root">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {}
    // //获取视窗宽度（兼容性写法）
    // let rootWidth = document.documentElement.clientWidth || document.body.clientWidth;
    //
    // //获取html元素
    // let rootDom = document.querySelector('html');
    //
    // //动态设置html的font-size（除以10是让浏览器的font-size达到比较合适目的）
    // rootDom.style.fontSize = rootWidth / 20 + 'px';
    // ﻿var designW = 750;  //设计稿宽
    // var font_rate = 100;
    // //适配
    // document.getElementsByTagName("html")[0].style.fontSize = document.body.offsetWidth / designW * font_rate + "px";
    // //监测窗口大小变化
    // window.addEventListener("orientationchange" in window ? "orientationchange" : "resize", function () {
    //     document.getElementsByTagName("html")[0].style.fontSize = document.body.offsetWidth / designW * font_rate + "px";
    // }, false);
</script>

<style lang="scss">
    .root {
        width: 100%;
        height: 100%;
    }

    html, body, div, h1, h2, h3, h4, h5, h6, p, dl, dt, dd, ol, ul, li, fieldset, form, label, input, legend, table, caption, tbody, tfoot, thead, tr, th, td, textarea, article, aside, audio, canvas, figure, footer, header, mark, menu, nav, section, time, video {
        margin: 0;
        padding: 0;
    }

    .c-red{
        color: red;
    }

    .c-grey{
        color: #dedede;
    }
</style>



// WEBPACK FOOTER //
// src/Root.vue